import React, { Component } from 'react';
import clsx from 'clsx';
//import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button, TextField, Typography, Switch } from '@material-ui/core';
import RenderTextFieldReduxMin from '../Complements/RenderTextFieldReduxMin';
import 'react-nice-input-password/dist/react-nice-input-password.css';
import PasswordConditionsIndicator from '../Complements/PasswordConditionsIndicator';
import PasswordBarLineIndicator from '../Complements/PasswordBarLineIndicator';
// import Title from '../Complements/Title';
import { IconButton } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { history } from '../../helpers/history';


const useStyles = (theme) => ({
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
    },
    divStandard: {
        padding: "20px",
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
    }
});


class ChangePasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            progressBarColors: ["#EFEFEF", "red", "orange", "yellow", "#C9FF37", "green"],
            isVisible: false
        }
    }

    handleChange = (data) => {
        this.setState({
            value: data.value
        })
    }

    handleVisible = () => {
        this.setState(prev => ({
            isVisible: !prev.isVisible
        }))
    }

    render() {
        const { classes, handleSubmit, handleChangePasswordNew, handleChangeRepeatPassword, handleChangeOldPassword, progress, user, validators, disableButton } = this.props;
        const { progressBarColors } = this.state;

        const dateAfterLogin = (str1) => {
            return new Date(str1) <= new Date();
        }
        const compare_date_change_password = dateAfterLogin(user.nextDateChangePassword);
        return (
            <div className={classes.divStandard}>
                <Grid xs={12} >
                    <Typography><IconButton disabled={compare_date_change_password} onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Cambio de Contraseña</Typography>
                </Grid>
                <form onSubmit={handleSubmit} autoComplete={false}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Field
                                name="oldPassword"
                                id="oldPassword"
                                required
                                allowZero={true}
                                className={clsx(classes.margin, classes.textField)}
                                component={RenderTextFieldReduxMin}
                                label={(user.flagResetPassword === 0) ? "INGRESE su contraseña antigua" : "INGRESE su contraseña provisional"}
                                type={this.state.isVisible ? "text" : "password"}
                                fullWidth
                                onChange={handleChangeOldPassword}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                name="passwordNew"
                                id="passwordNew"
                                required
                                className={clsx(classes.margin, classes.textField)}
                                onChange={handleChangePasswordNew}
                                InputLabelProps={
                                    {
                                        // style: { color: '#000000' }
                                    }
                                }
                                label="DIGITE su nueva contraseña"
                                type={this.state.isVisible ? "text" : "password"}
                                fullWidth />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Field
                                name="passwordRepeat"
                                id="passwordRepeat"
                                required
                                allowZero={true}
                                className={clsx(classes.margin, classes.textField)}
                                component={RenderTextFieldReduxMin}
                                label="REPITA su nueva contraseña"
                                type={this.state.isVisible ? "text" : "password"}
                                fullWidth
                                onChange={handleChangeRepeatPassword}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Switch color='primary' checked={this.state.isVisible} onChange={() => this.handleVisible()} />
                            <Typography component={'b'}>Mostrar contraseñas</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <PasswordBarLineIndicator progress={progress} progresscolor={progressBarColors[progress / 20]} />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <PasswordConditionsIndicator
                                validators={validators}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={(validators !== undefined) ? disableButton || !validators[0]?.validationState || !validators[1]?.validationState
                                    || !validators[2]?.validationState || !validators[3]?.validationState || !validators[4]?.validationState :
                                    disableButton || progress === 100 ? false : true}
                                size={"large"}
                                color='primary'
                                style={{ width: 'auto' }}
                            // className={classes.buttonStandard}
                            >
                                Aceptar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>

        );
    }
}

ChangePasswordForm.propTypes = {

};

const ChangePasswordReduxForm = reduxForm(
    {
        form: 'ChangePasswordForm',
    }
)(ChangePasswordForm)

export default setPropsAsInitial(withStyles(useStyles)(ChangePasswordReduxForm))
